<div class="item-detail"  fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <!-- <mat-icon class="icon-check">check_circle</mat-icon> -->
  <div>{{model.fraud_verification.custom_name}}</div>
</div>
